export default __webpack_public_path__ + "static/media/lead.8ff7ec56.svg";